export default __webpack_public_path__ + "static/media/mobile_feeding_status_uk.d2ab31c9.png";